<div class="side-nav" *ngIf="menuOpen; else minimizedSideNav">
  <mat-nav-list>
    <div class="logo py-2">
      <div class="company-logo">
        <img class="bloom-icon"
          src="{{ RESOURCE_SERVER_URL }}/assets/images/Header/Bloom_Insurance.jpg"
          alt=""
        />
      </div>
      <mat-divider></mat-divider>
      <div class="sidenav-profile">
        <img
          src="{{
            RESOURCE_SERVER_URL +
              '/assets/images/Underwriting_new/Header/Profile_top.svg'
          }}"
          alt=""
        />
        <div class="user-profile">
          <div class="user-name">
            <p>{{getUserName()}}</p>
          </div>
          <div class="user-id">
            <label>{{"profile.profileID"| translate}} - {{profilename()}}</label>
          </div>
        </div>
      </div>

      <div class="menu">
        <ng-container *ngIf="!finduserrole()">
          <a
          mat-list-item
          routerLink="/analytics"
          routerLinkActive="list-item-active"
        >
          <img
            src="{{
              this.RESOURCE_SERVER_URL +
                '/assets/images/Claim_Office/Side_Menu/Assure_Insights.svg'
            }}"
            alt=""
          />
          <span>{{ "claimOffice.label.fraudAnalytics" | translate }}</span>
        </a>
        <a
          mat-list-item
          routerLink="/process-claims"
          routerLinkActive="list-item-active"
        >
          <img
            src="{{
              this.RESOURCE_SERVER_URL +
                '/assets/images/Claim_Office/Side_Menu/Process_Claims.svg'
            }}"
            alt=""
          />
          <span>{{ "claimOffice.label.fraudAssessment" | translate }}</span>
        </a>
        </ng-container>
        <ng-container *ngIf="finduserrole()">
        <a
          mat-list-item
          routerLink="/admin"
          routerLinkActive="list-item-active"
        >
          <img
            src="{{
              this.RESOURCE_SERVER_URL +
                '/assets/images/Claim_Office/Side_Menu/Assure_Insights.svg'
            }}"
            alt=""
          />
          <span>{{ "claimOffice.label.assureInsights" | translate }}</span>
        </a>
        <a
          mat-list-item
          routerLink="/process-claims"
          routerLinkActive="list-item-active"
        >
          <img
            src="{{
              this.RESOURCE_SERVER_URL +
                '/assets/images/Claim_Office/Side_Menu/Process_Claims.svg'
            }}"
            alt=""
          />
          <span>{{ "claimOffice.label.processClaims" | translate }}</span>
        </a>
        <a
          mat-list-item
          routerLink="/billing-administration"
          routerLinkActive="list-item-active"
        >
          <img
            src="{{
              this.RESOURCE_SERVER_URL +
                '/assets/images/Claim_Office/Side_Menu/Claims.svg'
            }}"
            alt=""
          />
          <span>{{ "claimOffice.label.claims" | translate }}</span>
        </a>
      </ng-container>
      </div>
    </div>
  </mat-nav-list>
</div>

<ng-template #minimizedSideNav>
  <mat-nav-list>
    <div class="minimize-logo py-2">
      <div class="minimize-company-logo">
        <img class="bloom-icon"
          src="{{ RESOURCE_SERVER_URL }}/assets/images/Header/Bloom_Insurance.jpg"
          alt=""
        />
      </div>
      <mat-divider class="mt-3"></mat-divider>

      <div class="minimize-sidenav-profile">
        <img
          src="{{
            RESOURCE_SERVER_URL +
              '/assets/images/Underwriting_new/Header/Profile_top.svg'
          }}"
          alt=""
        />
      </div>

      <div class="menu">
        <ng-container *ngIf="finduserrole()">
        <a
          mat-list-item
          routerLink="/admin"
          routerLinkActive="list-item-active"
        >
          <img
            src="{{
              this.RESOURCE_SERVER_URL +
                '/assets/images/Claim_Office/Side_Menu/Assure_Insights.svg'
            }}"
            alt=""
          />
        </a>
        <a
          mat-list-item
          routerLink="/process-claims"
          routerLinkActive="list-item-active"
        >
          <img
            src="{{
              this.RESOURCE_SERVER_URL +
                '/assets/images/Claim_Office/Side_Menu/Process_Claims.svg'
            }}"
            alt=""
          />
        </a>
        <a
          mat-list-item
          routerLink="/billing-administration"
          routerLinkActive="list-item-active"
        >
          <img
            src="{{
              this.RESOURCE_SERVER_URL +
                '/assets/images/Claim_Office/Side_Menu/Claims.svg'
            }}"
            alt=""
          />
        </a>
        </ng-container>
        <ng-container *ngIf="!finduserrole()">
          <a
          mat-list-item
          routerLink="/analytics"
          routerLinkActive="list-item-active"
        >
          <img
            src="{{
              this.RESOURCE_SERVER_URL +
                '/assets/images/Claim_Office/Side_Menu/Assure_Insights.svg'
            }}"
            alt=""
          />
        </a>
        <a
          mat-list-item
          routerLink="/process-claims"
          routerLinkActive="list-item-active"
        >
          <img
            src="{{
              this.RESOURCE_SERVER_URL +
                '/assets/images/Claim_Office/Side_Menu/Process_Claims.svg'
            }}"
            alt=""
          />
        </a>
        </ng-container>
      </div>
    </div>
  </mat-nav-list>
</ng-template>
